module.exports = __webpack_public_path__ + "static/media/fb.58623b18.png";